import axios from '../../axios';
import { useQuery } from '@tanstack/react-query';
import type { TLessonBase, TError } from '@onesource/schemas';
import { ENTITY } from '../entity';

/**
 * Query key for fetching sub-lessons of a parent lesson
 */
export const getSubLessonsQueryKey = (parentId: string) => [ENTITY, 'lessons', parentId, 'sub-lessons'];

/**
 * Hook version of query key
 */
export const useGetSubLessonsQueryKey = (parentId: string) => getSubLessonsQueryKey(parentId);

interface UseGetSubLessonsOptions {
  enabled?: boolean;
}

/**
 * Hook to fetch all sub-lessons of a parent lesson with stats
 * Returns sub-lessons with videoCount, pdfCount, hasDownloadableAssets
 *
 * @param parentId - Parent lesson ID (UUID)
 * @param options - Query options (enabled, etc.)
 */
export const useGetSubLessons = (parentId: string, options?: UseGetSubLessonsOptions) => {
  const enabled = options?.enabled ?? true;

  return useQuery<TLessonBase[], TError>({
    queryKey: useGetSubLessonsQueryKey(parentId),
    queryFn: async () => {
      const res = await axios.get<TLessonBase[]>(`/community-hub/lessons/${parentId}/sub-lessons`);
      return res.data;
    },
    enabled: !!parentId && enabled,
    staleTime: 5 * 60 * 1000, // 5 minutes
  });
};
